import styled from 'styled-components';
import { blue } from '../../../utils/theme';

export const ShareButton = styled.div`
  top: initial;
  bottom: 20px;

  .share-link__text {
    color: ${blue};
  }

  .share-link__icons-wrapper {
    background: white;
  }

  .share-link__icon {
    background: white;

    &:after {
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/share/styles/share.style.js